import React from 'react';
import HeaderContainer from '../../containers/common/HeaderContainer';
import Navigation from '../../components/common/Navigation';
import { SideSpacer } from '../../components/common/Spacer';
import SearchContainer from '../../containers/prescription/SearchContainer';
import {
  HorizonContainer,
  HorizonWrapper,
} from '../../components/common/Container';
import Tab from '../../components/prescription/Tab';
import PrescriptionContainer from '../../containers/prescription/PrescriptionContainer';
import RecordContainer from '../../containers/record/RecordContainer';

const PrescriptionPage = ({history}) => {
  return (
    <>
      <HeaderContainer />
      <Navigation />
      <SideSpacer>
        <HorizonWrapper>
          <HorizonContainer ratio={1}>
            <SearchContainer />
          </HorizonContainer>
          <HorizonContainer ratio={3}>
            {/* <Tab history={history}/> */}
            <PrescriptionContainer history={history}/>
            {/* <RecordContainer history={history}/> */}
          </HorizonContainer>
        </HorizonWrapper>
      </SideSpacer>
    </>
  );
};

export default PrescriptionPage;
